<style lang="scss">
.mobile-img {
  display: none;
}
.checkout-form-custom-wraper .md{display: block !important;}
</style>

<template v-if="isJsonLoaded">
    <div class="vx-row attendee-reg-custom-wizard checkout-form-custom-wraper">
      <div class="vx-col md:w-1/1 w-full">
        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          :title="null"
          :subtitle="null"
          :startIndex="activeWizard"
          finishButtonText="Submit"
          @on-complete="save_SaveRegistrationForm"
        >
          <!-- <tab-content title="Default Form Settings" class="mb-5">
            
          </tab-content> -->
          <reg-ticket-pop
            :isSidebarActive="addNewDataSidebar"
            :data="eventadmindata"
          />
          <tab-content title="Tickets" class="mb-5">
            <div class="ticket-make-head">
              <p class="mb-0">Tickets</p>
              <div class="theme-info-area">
                <feather-icon class="ml-2 info-ico-i" icon="InfoIcon" title />
                <div class="theme-thumbnail-tooltip">
                  <div class="thumb-image-wrapper">
                    <img src="../../assets/images/default-theme.jpg" />
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/1 w-full h-100 mt-3">
              <div class="textbox-beside-wrap add-ticket-wrap">
                <!--<label>Add Tickets </label>
                <vs-select class="select-large">
                  <vs-select-item
                    v-model="defaultOptionSelected"
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in TicketAddOptions"
                    class="w-full"
                    @change="OpenModal()"
                  />
                </vs-select> -->

                <div>
                  <vs-radio
                    v-model="sourceselected"
                    vs-value="Paid"
                    class="mr-4"
                    vs-name="sourceselected"
                    @change="OpenModal"
                    >Paid</vs-radio
                  >
                  <vs-radio
                    v-model="sourceselected"
                    vs-value="Free"
                    class="mr-4"
                    vs-name="sourceselected"
                    @change="OpenModal"
                    >Free</vs-radio
                  >
                </div>
                <vs-button type="gradient mr-4" v-on:click="AddTickets()"
                  >Add Tickets</vs-button
                >
              </div>
            </div>
          </tab-content>
          <tab-content title="Form Builder" class="mb-5">
            <div class="vx-row" v-show="showAddButton">
              <div class="reg-from-entry-wrap">
                <label class="mr-4">Registration Forms </label>
                <vs-button type="gradient mr-4" v-on:click="addRecord()"
                  >Add Registration Forms</vs-button
                >
              </div>
            </div>
            <div class="text-right w-full">
              <vs-button
                v-show="showCancelButton"
                type="gradient mr-4"
                v-on:click="CancelRecord()"
                >Cancel</vs-button
              >
            </div>
            <br />
            <div v-show="showformStructure">
              <vs-tabs>
                <vs-tab label="Primary fileds">
                  <div class="tab-text">
                    <div class="vx-row">
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Form Name </label>
                          <vs-input
                            class="w-full"
                            name="FormName"
                            v-model="FormName"
                            data-vv-as="Form Name"
                          />
                        </div>
                      </div>

                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Assign To </label>
                          <v-select
                            class="track-select"
                            label="AssignTo"
                            name="Ticket"
                            :options="TicketList"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          />

                          <!-- :options="TicketList" -->
                        </div>
                      </div>
                    </div>
                    
                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Salutation </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showSalutation"
                          >Show Salutation</vs-checkbox
                        >
                        <!-- :vs-value="value"  -->
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsSalutationMandatory"
                          >Is Salutation Mandatory</vs-checkbox
                        >
                      </div>

                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="salutationlabel"
                            v-model="salutationLabel"
                            data-vv-as="salutation Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>FirstName </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showFirstName"
                          >Show FirstName</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsFirstNameMandatory"
                          >Is FirstName Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="firstNamelabel"
                            v-model="FirstNameLabel"
                            data-vv-as="FirstName Label"
                          />
                        </div>
                      </div>
                    </div>
                    

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>LastName </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showLastName"
                          >Show LastName</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsLastNameMandatory"
                          >Is LastName Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="LastNamelabel"
                            v-model="LastNameLabel"
                            data-vv-as="LastName Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>ProfilePicture </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showProfilePicture"
                          >Show ProfilePicture</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsProfilePictureMandatory"
                          >Is ProfilePicture Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="ProfilePicturelabel"
                            v-model="ProfilePictureLabel"
                            data-vv-as="ProfilePicture Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Email </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showEmail">Show Email</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsEmailMandatory"
                          >Is Email Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Emaillabel"
                            v-model="EmailLabel"
                            data-vv-as="Email Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Company </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showCompany">Show Company</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsCompanyMandatory"
                          >Is Company Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Companylabel"
                            v-model="CompanyLabel"
                            data-vv-as="Company Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Title </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showTitle">Show Title</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsTitleMandatory"
                          >Is Title Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Titlelabel"
                            v-model="TitleLabel"
                            data-vv-as="Title Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Mobile </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showMobile">Show Mobile</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsMobileMandatory"
                          >Is Mobile Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Mobilelabel"
                            v-model="MobileLabel"
                            data-vv-as="Mobile Label"
                          />
                        </div>
                      </div>
                    </div>


                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Tags </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showTags">Show Tags</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsTagsMandatory"
                          >Is Tags Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Tagslabel"
                            v-model="TagsLabel"
                            data-vv-as="Tags Label"
                          />
                        </div>
                      </div>
                    </div>


                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Type of Registrant </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showRegistrantTypes"
                          >Show Registrant Types</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsRegistrantTypesMandatory"
                          >Is Registrant Types Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap w-full h-100">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Tagslabel"
                            v-model="RegistrantTypesLabel"
                            data-vv-as="Tags Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>MailingAddress </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showMailingAddress"
                          >Show MailingAddress</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsMailingAddressMandatory"
                          >Is MailingAddress Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="MailingAddresslabel"
                            v-model="MailingAddressLabel"
                            data-vv-as="MailingAddress Label"
                          />
                        </div>
                      </div>
                    </div>


                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>City </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showCity">Show City</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsCityMandatory"
                          >Is City Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Citylabel"
                            v-model="CityLabel"
                            data-vv-as="City Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Zip </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showZip">Show Zip</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsZipMandatory"
                          >Is Zip Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Ziplabel"
                            v-model="ZipLabel"
                            data-vv-as="Zip Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>Country </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showCountry">Show Country</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsCountryMandatory"
                          >Is Country Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Countrylabel"
                            v-model="CountryLabel"
                            data-vv-as="Country Label"
                          />
                        </div>
                      </div>
                    </div>


                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100">
                        <label>State </label>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="showState">Show State</vs-checkbox>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsStateMandatory"
                          >Is State Mandatory</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="Statelabel"
                            v-model="StateLabel"
                            data-vv-as="State Label"
                          />
                        </div>
                      </div>
                    </div>

                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-2/12 w-full h-100"></div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsEnabledState"
                          >IsEnabledState</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100">
                        <vs-checkbox v-model="IsShowOtherStateTextBox"
                          >IsShowOtherStateTextBox</vs-checkbox
                        >
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Label </label>
                          <vs-input
                            class="w-full"
                            name="OtherStateDisplayLabel"
                            v-model="OtherStateDisplayLabel"
                            data-vv-as="Other State Display Label"
                          />
                        </div>
                      </div>
                    </div>


                    <br />
                    <div class="vx-row">
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>SubmitButtonDisplayLabel </label>
                          <vs-input
                            class="w-full"
                            name="SubmitButtonDisplaylabel"
                            v-model="SubmitButtonDisplaylabel"
                            data-vv-as="Submit Button Display Label"
                          />
                        </div>
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>LandingPageShowEventListLink </label>

                          <vs-checkbox v-model="LandingPageShowEventListLink"
                            >Show Landing Page Event List Link</vs-checkbox
                          >
                        </div>
                      </div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <label>Landing Page Show Hosted By Panel </label>

                          <vs-checkbox v-model="LandingPageShowHostedByPanel"
                            >Show Landing Page Hosted By Panel</vs-checkbox
                          >
                        </div>
                      </div>
                      <div class="vx-col md:w-6/12 w-full h-100 mt-5">
                        <div class="textbox-beside-wrap paying-top-client-wrap">
                          <label>Paying To </label>
                          <vs-input
                            class="w-full"
                            name="PayingTo"
                            v-model="PayingTo"
                            data-vv-as="Submit Button Display Label"
                          />
                        </div>
                      </div>

                      <!--<div class="vx-col md:w-1/12 w-full h-100">
                        <div class="textbox-beside-wrap ">
                          <label>Paying To Logo </label>
                        </div>
                      </div>-->
                      <div class="vx-col md:w-5/12 w-full h-100 mt-5">
                        <label>Paying To Logo </label>
                        <div class="paying-logo-wrap">
                          
                          <div class="paying-logo-image-wrap">
                            <img :src="imgSrc" class="rounded" />
                          </div>
                          <div>
                            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
                            <input
                              id="uploadAvatar"
                              type="file"
                              class="hidden"
                              ref="update_avatar_input"
                              @change="update_avatar($event, '960x192')"
                              accept="image/*"
                            />

                            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                            <vs-button
                              class="mr-4 mb-4"
                              @click="$refs.update_avatar_input.click()"
                              >Upload Paying To Logo</vs-button
                            >(recommended image dimension 960/192)
                            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                            <!--<vs-button type="border" color="danger">Remove Avatar</vs-button>-->
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </vs-tab>
                <vs-tab label="Dynamic fields">
                  <div class="tab-text">
                    <div class="vx-row">
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap">
                          <h4>Dynamic Form </h4>
                        </div>
                      </div>
                      <div class="vx-col md:w-3/12 w-full h-100"></div>
                      <div class="vx-col md:w-3/12 w-full h-100"></div>
                      <div class="vx-col md:w-4/12 w-full h-100">
                        <div class="textbox-beside-wrap"></div>
                      </div>
                    </div>
                    <br />
                      <!-- <div  class="vx-row">  -->
                      <!-- <div class="vx-col md:w-4/12 w-full h-100"> -->
                      <!-- DYNAMIC FORM BUILDER STARTS -->
                      <form data-vv-scope="step-2" class="dynamic-from-wrap">
                        <div class="vx-row">
                          <!-- <div class="vx-col w-full button-wrap">
                            <vs-button type="gradient">Preview</vs-button> 
                              <vs-popup
                                class="holamundo"
                                title="Form Preview"
                                :active.sync="popupActive"
                              >
                              
                                <div class="q-pa-md q-form-container">
                                  <h4>Form Preview</h4>
                                  <div v-for="(field, index) in fields" :key="index">
                                    <component
                                      v-model="fieldData[field.cid]"
                                      @input="onInput"
                                      v-bind:is="getElement(field)"
                                      :label="field.label"
                                      :required="field.required"
                                      :field_options="field.field_options"
                                      :id="field.cid"
                                      :cid="field.cid"
                                      :ref="field.cid"
                                      debounce="500"
                                    />
                                  </div>
                                </div>
                              </vs-popup>
                            </div> -->
                          <div class="w-full">
                            <q-form-builder
                              v-model="fields"
                              :source-fields="mySourceFields"
                            />
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="w-full">
                            <q-separator />
                          </div>
                        </div>
                      </form>
                      <!-- DYNAMIC FORM BUILDER ENDS -->
                      <!-- </div> -->

                      <!-- </div> -->
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>


              
              
              
              
             
            
          </tab-content>
          <tab-content
            title="Pre Signup"
            class="mb-5"
            
          >
            <div class="vx-row pre-sign-up-terms-wrap">
              <label class="mr-4">PreSignupTerms (Put HTML string)</label>
              <vs-textarea
                class="w-full"
                name="PreSignupTermsHtml"
                v-model="PreSignupTermsHtml"
                data-vv-as="PreSignupTerms Html"
              />
            </div>

            <br />
            <div class="vx-row">
              <div class="vx-col md:w-6/12 w-full h-100">
                <label>Acceptance Validation Display Label </label>
                <div class="textbox-beside-wrap">
                  <vs-textarea
                    class="w-full"
                    name="AcceptanceValidationDisplayLabel"
                    v-model="AcceptanceValidationDisplayLabel"
                    data-vv-as="MailingAddress Label"
                  />
                </div>
              </div>

              <div class="vx-col md:w-6/12 w-full h-100">
                <label>Acceptance Display Text </label>
                <div class="textbox-beside-wrap">
                  <vs-textarea
                    class="w-full"
                    name="AcceptanceDisplayText"
                    v-model="AcceptanceDisplayText"
                    data-vv-as="Acceptance Display Text"
                  />
                </div>
              </div>
            </div>
            <br />
            <div class="vx-row">
              <div class="vx-col md:w-2/12 w-full h-100">
                <div class="pre-accept-wrap">
                  <vs-checkbox v-model="RequireAcceptance"
                    >Pre-Signup Acceptance Required</vs-checkbox
                  >
                </div>
              </div>
              <div class="vx-col md:w-5/12 w-full h-100">
                <div class="textbox-beside-wrap pre-signup-option-wrap">
                  <label>OptInOne </label>
                  <vs-input
                    class="w-full"
                    name="OptInOne"
                    v-model="OptInOneText"
                    data-vv-as="OptInOne"
                  />
                  <vs-checkbox class="mt-3" v-model="OptInOneIsRequired"
                    >OptInOne Is Required</vs-checkbox
                  >
                </div>
                
              </div>
              <div class="vx-col md:w-5/12 w-full h-100">
                <div class="textbox-beside-wrap pre-signup-option-wrap">
                  <label>OptInTwo </label>
                  <vs-input
                    class="w-full"
                    name="OptInTwo"
                    v-model="OptInTwoText"
                    data-vv-as="OptInTwo"
                  />
                  <vs-checkbox class="mt-3" v-model="OptInTwoIsRequired"
                    >OptInTwo Is Required</vs-checkbox
                  >
                </div>
                
              </div>
            </div>
          </tab-content>
          <tab-content title="Publish" class="mb-5"> </tab-content>
        </form-wizard>
      </div>
    </div>
</template>
<script>
import regticketpop from "./RegTicketPop.vue";
import vSelect from "vue-select";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";
import axios from "@/axios.js";
import con from "@/firebase/firebaseInit.ts";

import ls from "@/common/localStorage";
let clientId = ls.getSessionValueByKey("Session_Client_Id");
let eventId = ls.getSessionValueByKey("Session_Event_Id");
var eventID = ls.getSessionValueByKey("Session_Event_Id");
var vm;
//---------------------------------------------------------------
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
let storageRef = con.storageRef;
var cn = ls.getSessionEventCollectionName();
import "q-form-builder/dist/css/app.6f06bd74.css";
import QFormBuilder from "../form-builder/QFormBuilder";

export default {
  components: {
    "reg-ticket-pop": regticketpop,
    FormWizard,
    TabContent,
    vSelect,
    quillEditor,
    QFormBuilder,
    // TextElement,
    // ParagraphElement,
    // CheckboxesElement,
    // RadioElement,
    // DateElement,
    // TimeElement,
    // DropdownElement,
    // EmailElement,
    // NameElement,
    // SimpleNameElement,
    // AddressElement,
    // PhoneElement,
    // FileElement,
    // PaymentElement,
    // TermsElement,
    // PageBreakElement,
    // SectionBreakElement,
  },
  data() {
    return {
      //---------------Dynamic form builder -----------------------------------------
      popupActive: false,
      fields: [],
      fieldData: [],
      mySourceFields: [
        { type: "text", icon: "text_format", label: "Text" },
        { type: "paragraph", icon: "text_fields", label: "Paragraph" },
        { type: "checkboxes", icon: "check_box", label: "Checkboxes" },
        { type: "radio", icon: "radio_button_checked", label: "Mult. Choice" },
        { type: "date", icon: "event", label: "Date" },
        { type: "time", icon: "access_time", label: "Time" },
        { type: "dropdown", icon: "arrow_drop_down", label: "Dropdown" },
        { type: "email", icon: "email", label: "Email" },
        //{ type: "name", icon: "person", label: "Name" },
        //{ type: "simple_name", icon: "person_outline", label: "Simple Name" },
        //{ type: "address", icon: "home", label: "Address" },
        { type: "phone", icon: "phone", label: "Phone" },
        { type: "file", icon: "cloud_upload", label: "File Upload" },
        //{ type: "payment", icon: "payment", label: "Payment" },
        //{ type: "terms", icon: "ballot", label: "Terms" },
        //{ type: "" },
        //{ type: "" },
        //{ type: "" },
        //{ type: "section_break", icon: "view_agenda", label: "Section Break" },
        //{ type: "page_break", icon: "call_to_action", label: "Page Break" }
      ],
      //----------------------------------------------------------------------

      ArrDefaultRegFormSettingsJSON: [],
      sourceselected: "",
      defaultOptionSelected: "0",

      TicketAddOptions: [
        { text: "Add Ticket", value: "0" },
        { text: "Paid", value: "1" },
        { text: "Free", value: "2" },
      ],
      showCancelButton: false,
      showAddButton: true,
      showformStructure: false,
      FormName: "Registration Form",
      FormType: "Free",
      TicketList: [],
      //------ LOGO update---------
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media",
      RegLogoImgFile: "",
      PayingToLogo: "",
      //----------------------------
      salutationLabel: "Salutation",
      showSalutation: true,
      IsSalutationMandatory: true,
      // value: "salutationvalue",
      //-------------------------
      FirstNameLabel: "First Name",
      showFirstName: true,
      IsFirstNameMandatory: true,
      //----------------------------
      LastNameLabel: "Last Name",
      showLastName: true,
      IsLastNameMandatory: true,
      //--------------------------

      showProfilePicture: true,
      IsProfilePictureMandatory: true,
      ProfilePictureLabel: "ProfilePictureLabel",
      //-------------------------
      EmailLabel: "Email",
      showEmail: true,

      //------------------------
      IsEmailMandatory: true,
      //---------------------------
      CompanyLabel: "Company",
      showCompany: true,
      IsCompanyMandatory: true,

      //-----------------------------

      TitleLabel: "Title",
      showTitle: true,
      IsTitleMandatory: true,
      //-----------------------------
      showMobile: true,
      IsMobileMandatory: true,
      MobileLabel: "Mobile",
      //----------------------------------
      showTags: true,
      IsTagsMandatory: true,
      TagsLabel: "Tags",
      //----------------------------
      showRegistrantTypes: true,
      IsRegistrantTypesMandatory: true,
      RegistrantTypesLabel: "Registrant Types",
      RegTypes: [],
      //------------------------------------
      showMailingAddress: true,
      IsMailingAddressMandatory: true,
      MailingAddressLabel: "MailingAddress",

      //---------------------------------
      showCity: true,
      IsCityMandatory: true,
      CityLabel: "City",
      //-------------------------------------
      showZip: true,
      IsZipMandatory: true,
      ZipLabel: "Zip",
      //-------------------------------------
      CountryLabel: "Country",
      showCountry: true,
      IsCountryMandatory: true,
      //---------------------------------------
      StateLabel: "State",
      showState: true,
      IsStateMandatory: true,
      IsShowOtherStateTextBox: true,
      OtherStateDisplayLabel: "Other State",
      IsEnabledState: true,
      //-------------------------
      SubmitButtonDisplaylabel: "Form Submit",
      //-------------------------------
      LandingPageShowEventListLink: true,
      //--------------------------------
      LandingPageShowHostedByPanel: true,
      //-----------------------------
      PayingTo: "E2M",

      activeWizard: 0,
      eventadmindata: {},
      addNewDataSidebar: false,
      countryList:
        "United States,United Kingdom,United Arab Emirates,Singapore,India,Afghanistan,Albania,Algeria,American Samoa,Andorra,Angola,Anguilla,Antarctica,Antigua and/or Barbuda,Argentina,Armenia,Aruba,Australia,Austria,Azerbaijan,Bahamas,Bahrain,Bangladesh,Barbados,Belarus,Belgium,Belize,Benin,Bermuda,Bhutan,Bolivia,Bosnia and Herzegovina,Botswana,Bouvet Island,Brazil,British Indian Ocean Territory,Brunei Darussalam,Bulgaria,Burkina Faso,Burundi,Cambodia,Cameroon,Canada,Cape Verde,Cayman Islands,Central African Republic,Chad,Chile,China,Christmas Island,Cocos (Keeling) Islands,Colombia,oros,Congo,Cook Islands,Costa Rica,Croatia (Hrvatska),Cuba,Cyprus,Czech Republic,Denmark,Djibouti,Dominica,Dominican Republic,East Timor,Ecudaor,Egypt,El Salvador,Equatorial Guinea,Eritrea,Estonia,Ethiopia,Falkland Islands (Malvinas),Faroe Islands,Fiji,Finland,France,France,Metropolitan,French Guiana,French Polynesia,French Southern Territories,Gabon,Gambia,Georgia,Germany,Ghana,Gibraltar,Greece,Greenland,Grenada,Guadeloupe,Guam,Guatemala,Guinea,Guinea-Bissau,Guyana,Haiti,Heard and Mc Donald Islands,Honduras,Hong Kong,Hungary,Iceland,Indonesia,Iran (Islamic Republic of),Iraq,Ireland,Israel,Italy,Ivory Coast,Jamaica,Japan,Jordan,Kazakhstan,Kenya,Kiribati,Korea, Democratic People's Republic of,Korea, Republic of,Kosovo,Kuwait,Kyrgyzstan,Lao People's Democratic Republic,Latvia,Lebanon,Lesotho,Liberia,Libyan Arab Jamahiriya,Liechtenstein,Lithuania,Luxembourg,Macau,Macedonia,Madagascar,Malawi,Malaysia,Maldives,Mali,Malta,Marshall Islands,Martinique,Mauritania,Mauritius,Mayotte,Mexico,Micronesia, Federated States of,Moldova, Republic of,Monaco,Mongolia,Montserrat,Morocco,Mozambique,Myanmar,Namibia,Nauru,Nepal,Netherlands,Netherlands Antilles,New Caledonia,New Zealand,Nicaragua,Niger,Nigeria,Niue,Norfork Island,Northern Mariana Islands,Norway,Oman,Pakistan,Palau,Panama,Papua New Guinea,Paraguay,Peru,Philippines,Pitcairn,Poland,Portugal,Puerto Rico,Qatar,Reunion,Romania,Russian Federation,Rwanda,Saint Kitts and Nevis,Saint Lucia,  Saint Vincent and the Grenadines,Samoa,San Marino,Sao Tome and Principe,Saudi Arabia,Senegal,Seychelles,Sierra Leone,Slovakia,Slovenia,Solomon Islands,Somalia,South Africa,  South Georgia South Sandwich Islands,South Sudan,Spain,Sri Lanka,St. Helena,St. Pierre and Miquelon,Sudan,Suriname,Svalbarn and Jan Mayen Islands,Swaziland,Sweden,Switzerland,Syrian Arab Republic,  Taiwan,Tajikistan,Tanzania,Thailand,Togo,Tokelau,Tonga,Trinidad and Tobago,Tunisia,Turkey,Turkmenistan,Turks and Caicos Islands,Tuvalu,Uganda,Ukraine,United States minor outlying islands,Uruguay,Uzbekistan,Vanuatu,Vatican City State,Venezuela,Vietnam,Virigan Islands (British),Virgin Islands (U.S.),Wallis and Futuna Islands,Western Sahara,Yemen,Yugoslavia,Zaire,Zambia,Zimbabwe",
      USAStateList:
        "Select an Option,Alabama,Alaska,Arizona,Arkansas,California,Colorado,Connecticut,Delaware,Florida,Georgia,Hawaii,Idaho,Illinois,Indiana,Iowa,Kansas,Kentucky,Louisiana,Maine,Maryland,Massachusetts,Michigan,Minnesota,Mississippi,Missouri,Montana,Nebraska,Nevada,New Hampshire,New Jersey,New Mexico,New York,North Carolina,North Dakota,Ohio,Oklahoma,Oregon,Pennsylvania,Rhode Island,South Carolina,South Dakota,Tennessee,Texas,Utah,Vermont,Virginia,Washington,West Virginia,Wisconsin,Wyoming",
      UKStateList:
        "Select an Option,Bedfordshire,Berkshire,Buckinghamshire,Cambridgeshire,Cheshire,Cornwall,CumbriaDerbyshire,Devon,Dorset,Durham,East RidingEast SussexEast YorkshireEssex,Gloucestershire,Greater London,Hampshire,Hertfordshire,Huntingdonshire,Kent,Lancashire,Leicestershire,Lincolnshire,MerseysideMiddlesex,Norfolk,Northamptonshire,Northumberland,Nottinghamshire,Oxfordshire,Rutland,Shropshire,Somerset,South Yorkshire,Staffordshire,Suffolk,Surrey,Tyne and WearWarwickshire,Westmorland,Wiltshire,Worcestershire,West Sussex,West Yorkshire",
      IndiaStateList:
        "Select an Option,Andhra Pradesh,Arunachal Pradesh,Assam,Bihar,Chhattisgarh,Goa,Gujarat,Haryana,Himachal Pradesh,Jharkhand,Karnataka,Kerala,Madhya Pradesh,Maharashtra,Manipur,Meghalaya,Mizoram,Nagaland,Odisha,Punjab,Rajasthan,Sikkim,Tamil Nadu,Telangana,Tripura,Uttarakhand,Uttar Pradesh,West Bengal,Andaman and Nicobar Islands, Dadra and Nagar Haveli,Daman & Diu,Jammu & Kashmir,Puducherry",
      SingaporeStateList:
        "Select an Option,Central Region,East Region,North Region,North-East Region,West Region",
      UAEStates:
        "Select an Option,Dubai,Abu Dhabi,Sharjah,Ajman,Ras al-Khaimah,Fujairah,Umm al-Quwain",

      //--------------------Pre sign up-----------------------------------------------------------------------

      PreSignupTermsHtml:
        "<p style='text-align: justify;'><strong>By accepting the submit button, you agree to the below terms and conditions</strong> </p>  <p style='text-align: justify;'>I&nbsp;understand that VTM2020 is planned to revive the ailing industry and&nbsp;I&nbsp;take responsibility as an attendee for the following:</p><ul><listyle='text-align: justify;'>To maintain professionalism during the entire duration of the event.</li><li style='text-align: justify;'>I&nbsp;understand that I am attending Virtual Travel Mart (VTM2020) as a Buyer and I will not sell/ promote/ market myself or my company.</li> <li style='text-align: justify;'>I also understand that my profile will be deleted and I will be asked to leave the Virtual Expo if I don’t abide to the above points.</li><li style='text-align: justify;'>I authorize VTM2020 and TravelGyaan to contact me through various marketing channels such as Email, WhatsApp, SMS and Calls during and before the event.</li><li style='text-align: justify;'>Rights of admission at VTM2020 is reserved and is at the sole discretion of the management.</li></ul>",
      RequireAcceptance: true,
      AcceptanceValidationDisplayLabel: "Please accept terms and condiotions.",
      AcceptanceDisplayText: "I Accept",
      OptInOneText: "Subscribe to news letter1",
      OptInOneIsRequired: true,
      OptInTwoText: "Subscribe to news letter2",
      OptInTwoIsRequired: true,
      isJsonLoaded: false
    };
  },
  watch: {
    FormType(val) {
      if (val == "1") {
        this.MapTo = "2";
      }
    },
    SubmitButtonText(val) {
      if (val.trim() == "") {
        this.SubmitButtonText = "Submit";
      }
    },
    SubmitMessage(val) {
      if (val.trim() == "") {
        this.SubmitMessage = "Thank you. You have successfully submitted.";
      }
    },
    // fields: {
    //   handler(val) {
    //     // console.debug(val)
    //   },
    //   deep: true,
    // },
  },
  methods: {
    onInput(val, id) {
      // console.debug(`${id}: ` + JSON.stringify(val))
    },
    getElement(field) {
      const nameParts = field.field_type.split("_");
      for (let i = 0; i < nameParts.length; i++) {
        nameParts[i] =
          nameParts[i].charAt(0).toUpperCase() + nameParts[i].slice(1);
      }
      return nameParts.join("") + "Element";
    },
    save_SaveRegistrationForm() {
      var objDefaultRegFormSettings = new Object();

      objDefaultRegFormSettings.FormType = vm.FormType;
      objDefaultRegFormSettings.FormName = vm.FormName;
      //-------------------------------------------------
      objDefaultRegFormSettings.salutationLabel = vm.salutationLabel;
      objDefaultRegFormSettings.showSalutation = vm.showSalutation;
      objDefaultRegFormSettings.IsSalutationMandatory =
        vm.IsSalutationMandatory;
      //---------------------------------------------------------------------------
      objDefaultRegFormSettings.FirstNameLabel = vm.FirstNameLabel;
      objDefaultRegFormSettings.showFirstName = vm.showFirstName;
      objDefaultRegFormSettings.IsFirstNameMandatory = vm.IsFirstNameMandatory;
      //---------------------------------------------------------------------------
      objDefaultRegFormSettings.LastNameLabel = vm.LastNameLabel;
      objDefaultRegFormSettings.showLastName = vm.showLastName;
      objDefaultRegFormSettings.IsLastNameMandatory = vm.IsLastNameMandatory;
      //---------------------------------------------------------------------------
      objDefaultRegFormSettings.showProfilePicture = vm.showProfilePicture;
      objDefaultRegFormSettings.IsProfilePictureMandatory =
        vm.IsProfilePictureMandatory;
      objDefaultRegFormSettings.ProfilePictureLabel = vm.ProfilePictureLabel;
      //---------------------------------------------------------------------------
      objDefaultRegFormSettings.EmailLabel = vm.EmailLabel;
      objDefaultRegFormSettings.showEmail = vm.showEmail;
      objDefaultRegFormSettings.IsEmailMandatory = vm.IsEmailMandatory;
      //--------------------------------------------------------------------------
      objDefaultRegFormSettings.CompanyLabel = vm.CompanyLabel;
      objDefaultRegFormSettings.showCompany = vm.showCompany;
      objDefaultRegFormSettings.IsCompanyMandatory = vm.IsCompanyMandatory;
      //--------------------------------------------------------------------
      objDefaultRegFormSettings.TitleLabel = vm.TitleLabel;
      objDefaultRegFormSettings.showTitle = vm.showTitle;
      objDefaultRegFormSettings.IsTitleMandatory = vm.IsTitleMandatory;
      //--------------------------------------------------------------------
      objDefaultRegFormSettings.showMobile = vm.showMobile;
      objDefaultRegFormSettings.IsMobileMandatory = vm.IsMobileMandatory;
      objDefaultRegFormSettings.MobileLabel = vm.MobileLabel;
      //---------------------------------------------------------------------
      objDefaultRegFormSettings.showTags = vm.showTags;
      objDefaultRegFormSettings.IsTagsMandatory = vm.IsTagsMandatory;
      objDefaultRegFormSettings.TagsLabel = vm.TagsLabel;
      //----------------------------------------------------------------------
      objDefaultRegFormSettings.IsShowRegFormType = vm.showRegistrantTypes;
      objDefaultRegFormSettings.IsRegistrantTypesMandatory =
        vm.IsRegistrantTypesMandatory;
      objDefaultRegFormSettings.RegTypeDisplayLabel = vm.RegistrantTypesLabel;
      objDefaultRegFormSettings.RegTypes = vm.RegTypes;
      //----------------------------------------------------------------------
      objDefaultRegFormSettings.showMailingAddress = vm.showMailingAddress;
      objDefaultRegFormSettings.IsMailingAddressMandatory =
        vm.IsMailingAddressMandatory;
      objDefaultRegFormSettings.MailingAddressLabel = vm.MailingAddressLabel;
      //----------------------------------------------------------------------
      objDefaultRegFormSettings.showCity = vm.showCity;
      objDefaultRegFormSettings.IsCityMandatory = vm.IsCityMandatory;
      objDefaultRegFormSettings.CityLabel = vm.CityLabel;
      //----------------------------------------------------------------------
      objDefaultRegFormSettings.showZip = vm.showZip;
      objDefaultRegFormSettings.IsZipMandatory = vm.IsZipMandatory;
      objDefaultRegFormSettings.ZipLabel = vm.ZipLabel;
      //----------------------------------------------------------------------
      objDefaultRegFormSettings.CountryLabel = vm.CountryLabel;
      objDefaultRegFormSettings.showCountry = vm.showCountry;
      objDefaultRegFormSettings.IsCountryMandatory = vm.IsCountryMandatory;
      //---------------------------------------------------------------------
      objDefaultRegFormSettings.StateLabel = vm.StateLabel;
      objDefaultRegFormSettings.showState = vm.showState;
      objDefaultRegFormSettings.IsStateMandatory = vm.IsStateMandatory;
      objDefaultRegFormSettings.IsShowOtherStateTextBox =
        vm.IsShowOtherStateTextBox;
      objDefaultRegFormSettings.OtherStateDisplayLabel =
        vm.OtherStateDisplayLabel;
      objDefaultRegFormSettings.IsEnabledState = vm.IsEnabledState;
      //-----------------------------------------------------------------------
      objDefaultRegFormSettings.SubmitButtonDisplaylabel =
        vm.SubmitButtonDisplaylabel;
      //-----------------------------------------------------------------------
      objDefaultRegFormSettings.LandingPageShowEventListLink =
        vm.LandingPageShowEventListLink;
      //-------------------------------------------------------------------
      objDefaultRegFormSettings.LandingPageShowHostedByPanel =
        vm.LandingPageShowHostedByPanel;
      //-----------------------------------------------------------------
      objDefaultRegFormSettings.PayingTo = vm.PayingTo;
      //-----------------------------------------------------------------------
      objDefaultRegFormSettings.PayingToLogo = vm.PayingToLogo;
      objDefaultRegFormSettings.RegLogoImgFile = vm.RegLogoImgFile;
      //------------------------------------------------------------------------------
      objDefaultRegFormSettings.countryList = vm.countryList;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.USAStateList = vm.USAStateList;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.UKStateList = vm.UKStateList;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.IndiaStateList = vm.IndiaStateList;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.SingaporeStateList = vm.SingaporeStateList;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.UAEStates = vm.UAEStates;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.PreSignupTermsHtml = vm.PreSignupTermsHtml;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.RequireAcceptance = vm.RequireAcceptance;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.AcceptanceValidationDisplayLabel =
        vm.AcceptanceValidationDisplayLabel;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.AcceptanceDisplayText =
        vm.AcceptanceDisplayText;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.OptInOne = vm.OptInOneText;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.OptInOneIsRequired = vm.OptInOneIsRequired;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.OptInTwo = vm.OptInTwoText;
      //-------------------------------------------------------------------------------
      objDefaultRegFormSettings.OptInTwoIsRequired = vm.OptInTwoIsRequired;
      //------------------------------ Dynamic Form Builder ---------------------------
      objDefaultRegFormSettings.DynamicFieldsJson = vm.fields;
      //-------------------------------------------------------------------------------
      //vm.ArrDefaultRegFormSettingsJSON.push(objDefaultRegFormSettings);
      debugger;
      objDefaultRegFormSettings.FormId = this.$route.params.FormId
      this.$vs.loading();
      this.$store
        .dispatch(
          "attendeeManagement/UpdateRegistrationForm",
          objDefaultRegFormSettings
        )
        .then((res) => {
          // this.attendee_search_list = this.attendee_list = res.filter((row) => {
          //   return row.IsPublished;
          // });
          this.$vs.loading.close();
          if(res.status == 200){
            vm.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Registration form",
              text: "Form submitted  successfully.",
            });

            this.$router.push("/event/registrationforms")
          }
          else{
            vm.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Registration form",
              text: "Something went wrong!",
            });
          }
          
        }).catch(err=>{
          this.$vs.loading.close();
        })
    },
    update_avatar(input, fileWH) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        debugger;
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            vm.RegLogoImgFile = file;
            const reader = new FileReader();
            reader.onload = (e) => {
              vm.imgSrc = e.target.result;

              //------------------------ Update LOGO ----------------------------------------------

              if (vm.RegLogoImgFile) {
                let regfile = vm.RegLogoImgFile;
                let metadata = {
                  contentType: file.type,
                };
                debugger;
                storageRef
                  .child(
                    cn +
                      "/Registration/LogoImage/" +
                      new Date().getTime() +
                      "_" +
                      regfile.name
                  )
                  .put(regfile, metadata)
                  .then(function (snapshot) {
                    snapshot.ref
                      .getDownloadURL()
                      .then(function (url) {
                        debugger;
                        console.log(url);
                        vm.PayingToLogo = url;
                      })
                      .catch(function (error) {});
                  })
                  .catch(function (error) {});
              } else {
                resolve({ status: 200, message: "Data Updated." });
              }
              //------------------------------------------------------------------------------------
            };
            reader.readAsDataURL(input.target.files[0]);
          } else {
            alert("File dimension does not match " + fileWH);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    AddTickets() {
      vm.addNewDataSidebar = true;
    },
    OpenModal() {
      debugger;
      if (vm.defaultOptionSelected != "0") {
        vm.addNewDataSidebar = true;
      }
    },
    addRecord() {
      debugger;
      vm.showformStructure = true;
      vm.showAddButton = false;
      vm.showCancelButton = true;
    },
    CancelRecord() {
      debugger;
      vm.showformStructure = false;
      vm.showAddButton = true;
      vm.showCancelButton = false;
    },
    fetchRegForm(){
      this.$vs.loading();
      this.$store.dispatch("attendeeManagement/fetchRegistrationForm", this.$route.params.FormId).then(res=>{
        this.$vs.loading.close();
        console.log(res)
        vm.isJsonLoaded = true
        if(res){
          vm.addRecord();
          vm.sourceselected = res.FormType;
          vm.FormType = res.FormType;
          vm.FormName = res.FormName;
          //-------------------------------------------------
          vm.salutationLabel = res.Salutation.salutationDisplayLabel;
          vm.showSalutation = res.Salutation.showSalutation;
          vm.IsSalutationMandatory =
            res.Salutation.IsSalutationMandatory;
          //---------------------------------------------------------------------------
          vm.FirstNameLabel = res.FirstName.firstNameDisplayLabel;
          vm.showFirstName = res.FirstName.IsShowfName;
          vm.IsFirstNameMandatory = res.FirstName.IsfNameMandatory;
          //---------------------------------------------------------------------------
          vm.LastNameLabel = res.LastName.lastNameDisplayLabel;
          vm.showLastName = res.LastName.IsShowlName;
          vm.IsLastNameMandatory = res.LastName.IslNameMandatory;
          //---------------------------------------------------------------------------
          vm.showProfilePicture = res.ProfilePicture.IsShowProfilePicture;
          vm.IsProfilePictureMandatory =
            res.ProfilePicture.IsProfilePictureMandatory;
          vm.ProfilePictureLabel = res.ProfilePicture.ProfilePictureDisplayLabel;
          //---------------------------------------------------------------------------
          vm.EmailLabel = res.Email.emailDisplayLabel;
          vm.showEmail = res.Email.IsShowEmail;
          vm.IsEmailMandatory = res.Email.IsEmailMandatory;
          //--------------------------------------------------------------------------
          vm.CompanyLabel = res.Company.companyDisplayLabel;
          vm.showCompany = res.Company.IsShowCompany;
          vm.IsCompanyMandatory = res.Company.IsCompanyMandatory;
          //--------------------------------------------------------------------
          vm.TitleLabel = res.Title.TitleDisplayLabel;
          vm.showTitle = res.Title.IsShowTitle;
          vm.IsTitleMandatory = res.Title.IsTitleMandatory;
          //--------------------------------------------------------------------
          vm.showMobile = res.Mobile.IsShowMobile;
          vm.IsMobileMandatory = res.Mobile.IsMobileMandatory;
          vm.MobileLabel = res.Mobile.mobileDisplayLabel;
          //---------------------------------------------------------------------
          vm.showTags = res.Tags.IsShowTags;
          vm.IsTagsMandatory = res.Tags.IsTagsMandatory;
          vm.TagsLabel = res.Tags.tagsDisplayLabel;
          //----------------------------------------------------------------------
          vm.showRegistrantTypes = res.RegistrationType.IsShowRegFormType;
          vm.IsRegistrantTypesMandatory =
            res.RegistrationType.IsRegistrantTypesMandatory;
          vm.RegistrantTypesLabel = res.RegistrationType.RegTypeDisplayLabel;
          vm.RegTypes = res.RegistrationType.RegTypes;
          //----------------------------------------------------------------------
          vm.showMailingAddress = res.MailingAddress.IsShowMailingAddress;
          vm.IsMailingAddressMandatory =
            res.MailingAddress.IsMailingAddressMandatory;
          vm.MailingAddressLabel = res.MailingAddress.MailingAddressLabel;
          //----------------------------------------------------------------------
          vm.showCity = res.City.IsShowCity;
          vm.IsCityMandatory = res.City.IsCityMandatory;
          vm.CityLabel = res.City.CityDisplayLabel;
          //----------------------------------------------------------------------
          vm.showZip = res.Zip.IsShowZip;
          vm.IsZipMandatory = res.Zip.IsZipMandatory;
          vm.ZipLabel = res.Zip.ZipDisplayLabel;
          //----------------------------------------------------------------------
          vm.CountryLabel = res.Country.CountryDisplayLabel;
          vm.showCountry = res.Country.IsShowCountryList;
          vm.IsCountryMandatory = res.Country.IsCountryMandatory;
          //---------------------------------------------------------------------
          vm.StateLabel = res.State.StateDisplayLabel;
          vm.showState = res.State.IsShowStateList;
          vm.IsStateMandatory = res.State.IsStateMandatory;
          vm.IsShowOtherStateTextBox =
            res.State.IsShowOtherStateTextBox;
          vm.OtherStateDisplayLabel =
            res.State.OtherStateDisplayLabel;
          vm.IsEnabledState = res.State.IsEnabledState;
          //-----------------------------------------------------------------------
          vm.SubmitButtonDisplaylabel =
            res.SubmitButtonDisplayLabel;
          //-----------------------------------------------------------------------
          vm.LandingPageShowEventListLink =
            res.LandingPageShowEventListLink;
          //-------------------------------------------------------------------
          vm.LandingPageShowHostedByPanel =
            res.LandingPageShowHostedByPanel;
          //-----------------------------------------------------------------
          vm.PayingTo = res.Payingto;
          //-----------------------------------------------------------------------
          vm.PayingToLogo = res.PayingToLogo;
          vm.RegLogoImgFile = res.RegLogoImgFile;
          //------------------------------------------------------------------------------
          vm.countryList = res.Country.countryList;
          //-------------------------------------------------------------------------------
          vm.USAStateList = res.State.USAStateList;
          //-------------------------------------------------------------------------------
          vm.UKStateList = res.State.UKStateList;
          //-------------------------------------------------------------------------------
          vm.IndiaStateList = res.State.IndiaStateList;
          //-------------------------------------------------------------------------------
          vm.SingaporeStateList = res.State.SingaporeStateList;
          //-------------------------------------------------------------------------------
          vm.UAEStates = res.State.UAEStates;
          //-------------------------------------------------------------------------------
          vm.PreSignupTermsHtml = res.PreSignupTerms.HTMLbody;
          //-------------------------------------------------------------------------------
          vm.RequireAcceptance = res.PreSignupTerms.RequireAcceptance;
          //-------------------------------------------------------------------------------
          vm.AcceptanceValidationDisplayLabel =
            res.PreSignupTerms.AcceptanceValidationDisplayLabel;
          //-------------------------------------------------------------------------------
          vm.AcceptanceDisplayText =
            res.PreSignupTerms.AcceptanceDisplayText;
          //-------------------------------------------------------------------------------
          vm.OptInOneText = res.PreSignupTerms.OptInOne;
          //-------------------------------------------------------------------------------
          vm.OptInOneIsRequired = res.PreSignupTerms.OptInOneIsRequired;
          //-------------------------------------------------------------------------------
          vm.OptInTwoText = res.PreSignupTerms.OptInTwo;
          //-------------------------------------------------------------------------------
          vm.OptInTwoIsRequired = res.PreSignupTerms.OptInTwoIsRequired;
          //------------------------------ Dynamic Form Builder ---------------------------
          vm.fields = res.DynamicFields;

        }
      }).catch(err=>{
            this.$vs.loading.close();
          })
    }
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    this.fetchRegForm();
  },
};
</script>